import styled, { css } from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: flex;
  width: 30rem;
  height: 80vh;
  min-width:300px;
  min-width:300px;
  flex-direction: column;
  font-size: 0.90rem;
  padding: 0.5rem;

  span{
    display: flex;
    font-size: 1;
    align-items: center;
    cursor: pointer;
    .icon{
      font-size: 1.75rem;
    }
  }

  ${({ loading }) =>
    loading &&
    css`
    opacity: 0.9;
    pointer-events: none;
  `}
`
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width:300px;
  flex-direction: column;
  .add--{
    display: flex;
    width: 100%;
    justify-content: right;
    label{
      display: flex;
      align-items: center;
      gap: 0.2rem;
      margin-bottom: 0.5rem;
      cursor: pointer;
    }
  }
  .search{
    height: 2.5rem;
    border-radius: 8px;
    padding: 0;
    margin-bottom: 0.5rem;
  }
  .list--options{
    display: flex;
    padding: 1rem;
    flex-direction: column;
    .back--lists{
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem;
      .icon{
        margin-left: -10px;
      }
    }
    .box{
      display: flex;
      margin-top: 15px;
      height: 40px;
      border-radius:6px; 
      background-color: #ffffff;
      justify-content: center;
      align-items: center;
      padding: 0 0.5rem;
      box-shadow: 0 -1px 10px 0 #ece8e8;
      
      input{
        border: none;
        outline: none;
        width: 100%;
      } 
      input:disabled {
        opacity: 0.5;
        background: transparent;
      }
    }
    .add--contacts{
      position: relative;
      margin-top: 1.75rem;
      .contacts--selecteds{
        display: flex;
        width: 100%;
        height: 10rem;
        padding: 1rem 0.5rem 0 0.5rem;
        gap: 0.5rem;
        overflow-y: auto;
        &::-webkit-scrollbar{
          width: 5px;
          height: 5px;
        }

        &::-webkit-scrollbar-thumb{
          background-color: rgb(0, 0, 0,0.2);
        }
        flex-flow: wrap;
        border-radius: 4px;
        border: 1px solid black;
      }

      .tag--{
        position: absolute;
        display: flex;
        width: 100%;
        top: -5px;
        left: 0px;
        z-index: 9;
        justify-content: center;
        align-items: center;
        label{
          display: flex;
          padding: 0rem 0.5rem 0 0.5rem;
          background-color: #f6f6f6;
        }
      }

      button{
        margin-top: 1rem;
        display: flex;
        width: 15rem;
        height: 2rem;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        gap: 0.5rem;
        border-radius: 4px;
        border: none;
        color: #ffffff;
        background-color: #1D86FF;
        cursor: pointer;
        &:hover{
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
      }
      
    }
    .area--selected{
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      width: 100%;
      height: 2rem;
      overflow-y: auto;
      &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
      }

      &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
      }
    }
    .area--options{
      display: flex;
      width: 100%;
      height: 115px;
      max-height: 115px;
      gap: 0.2rem;
      flex-direction: column;
      overflow-y:auto;
      &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
      }

      &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
      }
    }
  }
  ${({ back }) =>
    back &&
    css`
    height: calc(100% - 2rem);
  `}
`
export const List = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow: scroll;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }

  li{
    display: flex;
    height: 4.5rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    &:hover{
      background-color: #e8e8e8;
    }
    .avatar--{
      display: flex;
      width:4rem;
      height:3.65rem;
      justify-content: center;
      align-items: center;
      .icon--{
        display: flex;
        width:3.5rem;
        height:3.5rem;
        border-radius: 50%;
        justify-content: center;
        background-color:#1D86FF;
        color: #ffffff;
      }
    }
    .info--{
      display: flex;
      width: calc(100% - 4rem);
      max-width: calc(100% - 4rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name{
        display: flex;
        width:  100%;
        height: 50%;
        font-size: 1rem;
        color: black;
        .name--overflow{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .description{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
  }
`
export const Selected = styled.div`
  display: flex;
  height: 20px;
  max-width:130px;
  background-color: #1D86FF;
  align-items:center;
  border-radius: 4px;
  padding: 5px;
  .name{
    color: #f6f6f6f6;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .icon{
    font-size: 1.4rem;
    cursor: pointer;
  }
`
export const Save = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1.5rem;
  justify-content: center;
  align-items: center;
  
  button{
    display: flex;
    border: none;
    height: 2.5rem;
    gap: 1rem;
    padding: 10px;
    font-size: 1.3rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #1D86FF;
    border-radius:4px;
    color: #ffffff;
    &:hover{
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  ${({ loading }) =>
    loading &&
    css`
      &{
        button{
          width: 4rem;
          padding: 0.5rem;
          opacity: 0.9;
          pointer-events: none;
        }
      }
    `}
`
export const AddContacts = styled.div`
  display: flex;
  width: 45rem;
  height: 300px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const ContentPickList = styled.div`
  display: flex;
  width: 100%;
  height: 4rem;
  padding: 0.5rem;
  flex-direction: row;
  list-style-type: none;
  cursor: pointer;
  .avatar--{
    display: flex;
    height: 100%;
    width: 3rem;
    justify-content: center;
    align-items: center;
  }
  .avatar--list{
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    color: #ffffff;
    font-size: 1.5rem;
    justify-content: center;
    align-items: center;
    background-color: #1D86FF;
  }
  .info--{
    display: flex;
    width: calc(100% - 3rem);
    max-width: calc(100% - 3rem);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    .name{
      display: flex;
      width: 100%;
      height: 50%;
      font-size: 1.2rem;
      font-weight: 500;
      color: black;
      .name--{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .description{
      display: flex;
      width: 100%;
      height: 50%;
      font-size: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      border-bottom: 1px solid #eee;
    }
  }
`